module.exports = __webpack_public_path__ + "img/lb.f68fa259.png";